import { FC, ReactNode } from 'react';
import LoadingSpinner from '@/shared/components/LoadingSpinner/LoadingSpinner';
import { Redirect } from 'react-router-dom';
import { useGetUserQuery } from '@/features/user/userApi';

interface Props {
  children?: ReactNode;
}

const AuthorizationGuard: FC<Props> = ({ children }) => {
  const { data: userData, isLoading: isUserDataLoading } = useGetUserQuery(undefined, {});

  if (isUserDataLoading) {
    return <LoadingSpinner />;
  }

  if (!isUserDataLoading && !userData) {
    return <Redirect to="/" />;
  }

  return <>{children}</>;
};

export default AuthorizationGuard;
